import { render, staticRenderFns } from "./activity-info-sidebar.vue?vue&type=template&id=7dfbe998&scoped=true"
import script from "./activity-info-sidebar.vue?vue&type=script&lang=js"
export * from "./activity-info-sidebar.vue?vue&type=script&lang=js"
import style0 from "./activity-info-sidebar.vue?vue&type=style&index=0&id=7dfbe998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfbe998",
  null
  
)

export default component.exports